export interface ValidationRule {
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  min?: number;
  max?: number;
  pattern?: RegExp;
  email?: boolean;
  url?: boolean;
}

export const validateField = (value: any, rules: ValidationRule): string | null => {
  if (rules.required && (value === undefined || value === null || value === '')) {
    return 'This field is required';
  }

  if (value === undefined || value === null || value === '') {
    return null; // Skip other checks if empty and not required
  }

  if (typeof value === 'string') {
    if (rules.minLength && value.length < rules.minLength) {
      return `Minimum length is ${rules.minLength}`;
    }
    if (rules.maxLength && value.length > rules.maxLength) {
      return `Maximum length is ${rules.maxLength}`;
    }
    if (rules.pattern && !rules.pattern.test(value)) {
        return 'Invalid format';
    }
    if (rules.email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) return 'Invalid email address';
    }
    if (rules.url) {
        try {
            new URL(value);
        } catch (_) {
            return 'Invalid URL';
        }
    }
  }

  if (typeof value === 'number') {
      if (rules.min !== undefined && value < rules.min) return `Value must be at least ${rules.min}`;
      if (rules.max !== undefined && value > rules.max) return `Value must be at most ${rules.max}`;
  }

  return null;
};